import React from 'react';
import { Box, Heading, Text, Link } from '@chakra-ui/react';

import useLang from '@/hooks/useLang';

import { useImaginationRoom } from '@invitato/imagination-room';

import LineDecoration from '@/components/Common/LineDecoration';

import { ENABLE_VIDEO_PREWEDDING } from '@/constants/feature-flags';
import loveStoryData from '@/constants/love-story';
import { ID_LOVESTORY_SECTION } from '@/constants/identifier';
import { ENABLE_LOVE_STORY_CONTENT } from '@/constants/feature-flags';
import { THE_BRIDE, YOUTUBE_PREWEDDING_LINK } from '@/constants';
import { IMG_LOVE_STORY } from '@/constants/assets';

import LoveStoryCard from './LoveStoryCard';
import txtWording from './locales';
import { TEXT_PROPS } from '@/constants/default-props';

function LoveStory() {
  const { onGetFinalContent, onGetFinalName } = useImaginationRoom();
  const lang = useLang();
  const finalLoveStory = loveStoryData;

  return (
    <Box
      bgColor="bgPrimary"
      padding={ENABLE_LOVE_STORY_CONTENT ? '3rem 0rem 7rem 0rem' : '3rem 0rem 3rem 0rem'}
      name={ID_LOVESTORY_SECTION}
      pos="relative"
    >
      {false && (
        <Heading
          {...TEXT_PROPS.heading}
          fontWeight="medium"
          textAlign="center"
          color="mainColorText"
        >
          <>
            {onGetFinalName('coupleName', THE_BRIDE)} are <br />
            Getting Married!
          </>
        </Heading>
      )}

      <Heading {...TEXT_PROPS.heading} fontWeight="medium" textAlign="center" color="mainColorText">
        Our Story
      </Heading>

      <Box width="100%" overflow="hidden">
        <Box
          position="relative"
          sx={{
            width: '240px',
            height: '330px',

            '@media screen and (max-width: 400px)': {
              width: '220px',
              height: '300px',
            },
          }}
          background={`url(${onGetFinalContent('IMG_LOVE_STORY', IMG_LOVE_STORY)})`}
          bgSize="cover"
          bgPosition="center"
          margin="30px auto"
        >
          <Box
            position="absolute"
            sx={{
              top: '-33px',
              left: '-190px',
              '@media screen and (max-width: 400px)': {
                top: '-63px',
                left: '-180px',
              },
            }}
          >
            <LineDecoration width="280px" height="380px" />
          </Box>
        </Box>
      </Box>

      {ENABLE_VIDEO_PREWEDDING && (
        <Link href={YOUTUBE_PREWEDDING_LINK} target="_blank">
          <Text
            fontFamily="body_lv2"
            letterSpacing="2px"
            textTransform="uppercase"
            fontSize="md"
            textDecoration="underline"
            textAlign="center"
            marginBottom="30px"
            color="mainColorText"
          >
            {txtWording.video[lang]}
          </Text>
        </Link>
      )}

      {ENABLE_LOVE_STORY_CONTENT && <LoveStoryCard loveStoryData={finalLoveStory} />}
    </Box>
  );
}

export default LoveStory;
